import React from 'react';

function Portfolio() {
  return (
    <section className="work-sticky section-padding pt-60 sub-bg">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 items">
            <div className="img">
              <img src="/light/assets/imgs/works/stand/1.jpg" alt="" />
            </div>
          </div>
          <div className="col-lg-4 items">
            <div className="cont">
              <div className="sticky-item">
                <h6 className="sub-title opacity-7 mb-10">Branding</h6>
                <h5 className="mb-15">Aevoe Brand</h5>
                <p>
                  we have been using graphic design and websites to bring brands
                  to life.
                </p>
                <a href="/light/project6" className="rmore mt-30">
                  <span className="sub-title">View Project</span>
                  <img
                    src="/light/assets/imgs/arrow-right.png"
                    alt=""
                    className="icon-img-20 ml-5"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 items">
            <div className="cont">
              <div className="sticky-item">
                <h6 className="sub-title opacity-7 mb-10">Photography</h6>
                <h5 className="mb-15">Nice guy</h5>
                <p>
                  we have been using graphic design and websites to bring brands
                  to life.
                </p>
                <a href="/light/project6" className="rmore mt-30">
                  <span className="sub-title">View Project</span>
                  <img
                    src="/light/assets/imgs/arrow-right.png"
                    alt=""
                    className="icon-img-20 ml-5"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-8 items">
            <div className="img">
              <img src="/light/assets/imgs/works/stand/3.jpg" alt="" />
            </div>
          </div>
          <div className="col-lg-8 items">
            <div className="img">
              <img src="/light/assets/imgs/works/stand/5.jpg" alt="" />
            </div>
          </div>
          <div className="col-lg-4 items">
            <div className="cont">
              <div className="sticky-item">
                <h6 className="sub-title opacity-7 mb-10">Branding</h6>
                <h5 className="mb-15">Digital Design</h5>
                <p>
                  we have been using graphic design and websites to bring brands
                  to life.
                </p>
                <a href="/light/project6" className="rmore mt-30">
                  <span className="sub-title">View Project</span>
                  <img
                    src="/light/assets/imgs/arrow-right.png"
                    alt=""
                    className="icon-img-20 ml-5"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 items">
            <div className="cont">
              <div className="sticky-item">
                <h6 className="sub-title opacity-7 mb-10">Branding</h6>
                <h5 className="mb-15">Digital Design</h5>
                <p>
                  we have been using graphic design and websites to bring brands
                  to life.
                </p>
                <a href="/light/project6" className="rmore mt-30">
                  <span className="sub-title">View Project</span>
                  <img
                    src="/light/assets/imgs/arrow-right.png"
                    alt=""
                    className="icon-img-20 ml-5"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-8 items">
            <div className="img">
              <img src="/light/assets/imgs/works/stand/7.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
